/**
 * Тарифные планы Orda OS.
 *
 * TODO: финальные цены — заполнить когда определишься (сейчас placeholder).
 * Формат: { amount: "15 000", currency: "₸", period: "/мес" } через i18n.
 * Сейчас числа жёстко в i18n/{ru,kk,en}.ts → меняй там.
 */

export type TierId = "starter" | "delivery" | "pro" | "enterprise" | "network";

export const TIER_ORDER: TierId[] = ["starter", "delivery", "pro", "enterprise", "network"];

export const POPULAR_TIER: TierId = "pro";

/** Тарифы без фиксированной цены — показываются как «По запросу» (только лендинг). */
export const CUSTOM_PRICE_TIERS: ReadonlySet<TierId> = new Set<TierId>(["network"]);
